module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chatZoneMenuContainer"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("채팅")]), _vm._v(" "), _c('div', {
    staticClass: "channel-list"
  }, _vm._l((_vm.chatZoneArray), function(item, index) {
    return _c('chatZoneMenuItems', {
      key: index,
      attrs: {
        "item": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "extension-menu left-chat-header-menu-box"
  }, [_c('chatSettingMenu', {
    attrs: {
      "id": "chatSettingMenu"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3615c0fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-zone-menu.vue
// module id = 96
// module chunks = 0